import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function DashboardSellNuc() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const isAuth = localStorage.getItem('auth');
    if (isAuth !== 'true') navigate('/');

    axios
      .get('https://crypto-co.nugenesisou.com/otc-sale/api/otc-sales')
      .then((res) => setData(res.data))
      .catch((err) => console.error(err));
  }, [navigate]);

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>OTC Sales Dashboard</h2>

      {/* Scrollable wrapper (both axes) */}
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableHeaderRow}>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Preferred Stablecoin</th>
              <th style={styles.th}>Wallet ID</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>KYC Image</th>
              <th style={styles.th}>Selfie Image</th>
              <th style={styles.th}>Miner Status</th>
              <th style={styles.th}>Miner Position</th>
              <th style={styles.th}>Country of Residence</th>
              <th style={styles.th}>KYC Verification Status</th>
              <th style={styles.th}>Are you a Miner</th>
              <th style={styles.th}>Submission Date</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index} style={styles.tableRow}>
                <td style={styles.td}>{item.name}</td>
                <td style={styles.td}>{item.email}</td>
                <td style={styles.td}>{item.preferred_stablecoin}</td>
                <td style={styles.td}>{item.wallet_id}</td>
                <td style={styles.td}>{item.amount_to_sell}</td>
                <td style={styles.td}>
                  <a
                    href={`https://crypto-co.nugenesisou.com/uploads/${item.kyc_image_name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                  >
                    View
                  </a>
                </td>
                <td style={styles.td}>
                  <a
                    href={`https://crypto-co.nugenesisou.com/uploads/${item.selfie_image}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                  >
                    View
                  </a>
                </td>
                <td style={styles.td}>{item.is_miner || 'N/A'}</td>
                <td style={styles.td}>{item.miner_position || 'N/A'}</td>
                <td style={styles.td}>{item.country_of_residence || 'N/A'}</td>
                <td style={styles.td}>{item.kyc_verification_status || 'N/A'}</td>
                <td style={styles.td}>{item.is_miner || 'N/A'}</td>
                <td style={styles.td}>{item.created_at || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: '30px',
    backgroundColor: '#f4f4f4',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    margin: 'auto',
  },
  header: {
    fontSize: '36px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '20px',
    textAlign: 'center',
  },

  /* NEW: scrollable wrapper */
  tableWrapper: {
    maxHeight: '70vh',        // vertical scroll area
    overflow: 'auto',         // enables both horizontal & vertical scrolling
    borderRadius: '8px',
    border: '1px solid #ddd',
    background: '#fff',
  },

  table: {
    width: '100%',
    borderCollapse: 'collapse',
    color: 'black',
    minWidth: '1200px',       // forces horizontal scroll on narrow screens
    tableLayout: 'auto',
  },

  /* Sticky header */
  tableHeaderRow: {
    backgroundColor: 'rgb(0, 229, 255)',
    color: 'white',
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'left',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  th: {
    padding: '12px 10px',
    borderBottom: '1px solid #ddd',
    whiteSpace: 'nowrap',     // keep headers on one line for better horizontal scroll
  },
  tableRow: {
    backgroundColor: '#fff',
    borderBottom: '1px solid #eee',
  },
  td: {
    color: 'black',
    padding: '10px',
    verticalAlign: 'top',
    borderBottom: '1px solid #f1f1f1',
    whiteSpace: 'nowrap',     // optional: keeps cells on one line; remove if you prefer wrapping
  },
  link: {
    color: '#0b69ff',
    textDecoration: 'none',
    fontWeight: 500,
  },
  kycImage: {
    width: '80px',
    height: 'auto',
    borderRadius: '5px',
  },
};
